import { useDispatch, useSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import type { RootState, AppDispatch } from './store';

// Custom hook to get the typed dispatch function
export const useAppDispatch = () => useDispatch<AppDispatch>();

// Custom hook to get the typed selector function
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
